import { getPropertyLabel } from '../style-plugins/index.js';
import { parseThemeColor } from '../../utils/theme-helper.js';

export const resolveColor = (key) => {
    if (!key) return undefined;
    // If it's already a hex/rgb/hsl color, return it directly
    if (key.startsWith('#') || key.startsWith('rgb') || key.startsWith('hsl')) {
        return key;
    }
    return parseThemeColor(key);
};

export const cleanLabel = (propertyKey, defaultLabel) => {
    return getPropertyLabel(propertyKey, defaultLabel);
};
